import { refreshCalendarStoreWithCalendarCacheData } from 'owa-calendar-surface-select-calendar';
import { orchestrator } from 'satcheljs';
import { calendarCacheInitializedForAccount } from 'owa-calendar-cache-loader';

orchestrator(calendarCacheInitializedForAccount, actionMessage => {
    refreshCalendarStoreWithCalendarCacheData(actionMessage.userId);
});
